module.exports = __webpack_public_path__ + "static/media/eap2.0ca915c3.md";